export const industriesOptions = [
  { label: 'Accounting/Bookkeeping', value: 'Accounting/Bookkeeping' },
  { label: 'Agriculture/Farming', value: 'Agriculture/Farming' },
  { label: 'Cleaning Services', value: 'Cleaning Services' },
  { label: 'Construction/Trade', value: 'Construction/Trade' },
  { label: 'Delivery/Transportation', value: 'Delivery/Transportation' },
  { label: 'Electrical', value: 'Electrical' },
  { label: 'Event Management/Staffing', value: 'Event Management/Staffing' },
  { label: 'Franchises/Chains', value: 'Franchises/Chains' },
  { label: 'Healthcare', value: 'Healthcare' },
  { label: 'Home Health and Hospice', value: 'Home Health and Hospice' },
  { label: 'HVAC', value: 'HVAC' },
  { label: 'IT Services', value: 'IT Services' },
  { label: 'Landscaping', value: 'Landscaping' },
  { label: 'Nonprofit', value: 'Nonprofit' },
  { label: 'Painting', value: 'Painting' },
  { label: 'Pet Sitting/Dog Walking', value: 'Pet Sitting/Dog Walking' },
  { label: 'Plumbing', value: 'Plumbing' },
  { label: 'Pool', value: 'Pool' },
  { label: 'Real Estate/Facility Management', value: 'Real Estate/Facility Management' },
  { label: 'Restoration/Mitigation', value: 'Restoration/Mitigation' },
  { label: 'Roofing', value: 'Roofing' },
  { label: 'Sales', value: 'Sales' },
  { label: 'Security', value: 'Security' },
  { label: 'Solar', value: 'Solar' },
  { label: 'Technology/Audio Video', value: 'Technology/Audio Video' },
  { label: 'Other', value: 'Other' },
];

export const companySizeOptions = [
  { label: '1-3', value: '1-3' },
  { label: '4-10', value: '4-10' },
  { label: '11-25', value: '11-25' },
  { label: '26-50', value: '26-50' },
  { label: '51-100', value: '51-100' },
  { label: '100+', value: '100+' },
];

export const jobTitleOptions = [
  { label: 'CEO/Owner', value: 'CEO/Owner' },
  { label: 'Accountant', value: 'Accountant' },
  { label: 'Human Resources', value: 'Human Resources' },
  { label: 'Operations Manager / Supervisor', value: 'Operations Manager / Supervisor' },
  { label: 'Contractor', value: 'Contractor' },
  { label: 'Employee', value: 'Employee' },
  { label: 'Operator', value: 'Operator' },
];
